import { ActionIcon } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { Panel } from 'components/Panel';
import { tKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';

import type { Automation } from '../../../api';
import { useEditAutomation } from '../../AutomationWizard';

import { ActionRow } from './ActionRow';

type ActionsPanelProps = {
  automation: Automation;
  isLoading: boolean;
};

export const ActionsPanel = ({ automation, isLoading }: ActionsPanelProps) => {
  const { t } = useTranslation();

  const onClickEdit = useEditAutomation();

  return (
    <Panel
      isLoading={isLoading}
      title={t(tKeys.AUTOMATION.WIZARD.STEPS.ACTIONS)}
      topRight={
        <ActionIcon onClick={() => onClickEdit(automation.id, 3)} variant="default">
          <IconPencil stroke={1.5} size={18} />
        </ActionIcon>
      }
    >
      {automation.actions.map(action => (
        <ActionRow key={action.id} action={action} model={automation.targetModel} />
      ))}
    </Panel>
  );
};
